import { InvestorToolPage } from "./InvestorToolPage";

export function KeyFiguresPage() {
  return <InvestorToolPage translationKey="keyFigures" toolName="IA" />;
}
